import React, { useCallback } from "react";
import clsx from "clsx";

import { IActionTeachingMaterial, IActionLessons } from "../../../../state";
import { ReactComponent as CheckIcon } from "../../../../assets/svg/check.svg";
import { ReactComponent as CheckIconOff } from "../../../../assets/images/ActionList/check_icon_off.svg";
import { ReactComponent as CheckIconOn } from "../../../../assets/images/ActionList/check_icon_on.svg";

import styles from "./VolumeList.module.scss";

export interface IVolumeListProps {
  activeVolumeId: number | null;
  setActiveVolumeId: React.Dispatch<React.SetStateAction<number | null>>;
  volumeList: IActionTeachingMaterial[];
  hasAnsweredLessons: (volume: IActionTeachingMaterial) => boolean;
}

const VolumeList: React.FC<IVolumeListProps> = ({
  activeVolumeId,
  setActiveVolumeId,
  volumeList,
  hasAnsweredLessons,
}) => {
  // 既存の反省内容チェック（チェックマーク表示用）
  const allReflectionsComplete = useCallback(volume => {
    if (!volume.lessons || volume.lessons.length === 0) {
      return false;
    }
    return volume.lessons.every(
      (lesson: IActionLessons) =>
        lesson.reflection_realization_reference !== null,
    );
  }, []);

  const isSelectedVolume = (volume: IActionTeachingMaterial) => {
    return activeVolumeId === volume.id && hasAnsweredLessons(volume);
  };

  return (
    <div className={styles.wrapper}>
      {volumeList.map(volume => (
        <div
          className={`${styles.volumeContainer} ${
            isSelectedVolume(volume) ? styles.selectedVolume : ""
          } ${
            hasAnsweredLessons(volume) ? "" : styles.volumeContainerDisabled
          }`}
          onClick={() => {
            if (hasAnsweredLessons(volume)) {
              setActiveVolumeId(volume.id);
            }
          }}
          key={volume.id}
        >
          <div className={styles.media}>
            <div className={styles.imageContainer}>
              <img
                src={volume.image_url}
                alt=""
                className={styles.volumeImage}
              />
              {allReflectionsComplete(volume) && (
                <CheckIcon className={styles.checkIcon} />
              )}
            </div>
            <span
              className={`${
                volume.lessons && volume.lessons.length > 0
                  ? styles.volumeTitle
                  : styles.disabledVolume
              }`}
            >
              {volume.name}
            </span>
          </div>
          <div className={styles.checkList}>
            {volume.lessons?.map(lesson => {
              const isReflected =
                lesson.reflection_realization_reference !== null;
              const isActive = isSelectedVolume(volume);
              let icon;
              if (isReflected) {
                icon = isActive ? <CheckIconOn /> : <CheckIconOff />;
              } else {
                icon = (
                  <span
                    className={clsx(isActive ? styles.dotOn : styles.dotOff)}
                  />
                );
              }
              return (
                <div className={styles.checkItem} key={lesson.id}>
                  {icon}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VolumeList;
